<template>
  <Submit class="block" :is-loading="isLoading" :text="label" @click="$emit('submit')" />
</template>

<script setup>
import Submit from "./common/FormSubmit.vue";

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "Submit Your Request",
  },
});

defineEmits(["submit"]);
</script>
